import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { remarketingQuery, type RemarketingRow } from '../../api/easeedeskDashboards'
import { Content } from '../../ui/Shell'
import { NotInstalled } from './WallHeader'

/**
 * "Sku remarketing notifications" - `easeedesk-dashboards/Remarketing_number::index`,
 * macheta `views/version-3/dashboards/easeedesk/remarketing/index.php`.
 *
 * Doua tabele rosii, cu aceleasi sapte randuri: unul pe saptamana aleasa in
 * casuta de sus, altul pe tot ce a fost vreodata. Casuta e aceeasi lista de
 * saptamani, numarate de la 30 iulie 2017 si cu cea mai noua prima; ecranul
 * se deschide pe ea, ca in portal.
 *
 * CELE DOUA PANOURI DE GRAFIC NU S-AU ADUS, si nu e o scapare. In portal ele
 * sunt DEJA stinse: in `public/js/dashboards/easeedesk.js`, `buildCharts` si
 * chemarea lui sunt comentate, iar `init()` cheama numai `buildTables` - deci
 * `#currentChart` si `#totalChart` sunt goale si azi. amCharts a iesit din
 * portal pe 6 septembrie 2026 si nu se intoarce pentru doua casute goale.
 */

const HEAD_STYLE = {
  textAlign: 'center' as const,
  backgroundColor: '#e21937',
  color: '#ffffff',
  fontSize: 20,
  padding: '10px 5px',
}

const ROW_STYLE = {
  textAlign: 'center' as const,
  backgroundColor: '#e21937',
  color: '#fff',
  fontSize: 15,
}

function Table({ id, heading, rows }: { id: string; heading: string; rows: RemarketingRow[] }) {
  return (
    <div id={id} className="table-responsive" style={{ marginTop: 10 }}>
      <table className="table table-bordered">
        <thead>
          <tr style={HEAD_STYLE}>
            <th colSpan={2} style={{ padding: '10px 5px', color: '#ffffff' }}>
              {heading}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.title} style={ROW_STYLE}>
              <td style={{ width: '80%' }}>{row.title}</td>
              <td>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export function RemarketingPage() {
  /* Gol = capatul alege singur ziua de azi; prima saptamana o pune lista. */
  const [week, setWeek] = useState<{ from: string; to: string }>({ from: '', to: '' })
  const q = useQuery(remarketingQuery(week.from, week.to))
  const page = q.data
  const weeks = page?.weeks ?? []
  const chosen = week.from ? `${week.from}|${week.to}` : weeks[0] ? `${weeks[0].from}|${weeks[0].to}` : ''

  return (
    <Content>
      <div className="row" style={{ margin: 0 }}>
        <div className="col-md-6">
          <h4>{page?.title ?? 'Sku remarketing notifications'}</h4>
        </div>
        <div className="col-md-6">
          <div className="pull-right">
            <select
              className="form-control"
              id="rangepicker"
              aria-label="Week"
              value={chosen}
              onChange={(e) => {
                const [from, to] = e.target.value.split('|')
                setWeek({ from, to })
              }}
            >
              {weeks.map((w) => (
                <option key={`${w.from}|${w.to}`} value={`${w.from}|${w.to}`}>
                  {`Week ${w.week} of ${w.year} (${w.start} - ${w.end})`}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {page && !page.ready ? <NotInstalled what="remarketing notifications" /> : null}

      <div className="row" style={{ marginTop: 20 }}>
        <div className="col-md-7">
          <Table
            id="currentTable"
            heading={page ? `${page.from} - ${page.to}` : ''}
            rows={page?.current ?? []}
          />
        </div>
      </div>

      <div className="row" style={{ marginTop: 20 }}>
        <div className="col-md-7">
          <Table id="totalTable" heading="TOTAL" rows={page?.total ?? []} />
        </div>
      </div>
    </Content>
  )
}
